import { memo, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { AlertCircle } from 'lucide-react';
import { DraftIssuesContext } from '../useDraftIssues';
import { DraftIssueList } from './DraftIssuesSidebar';

export const DraftIssueSummary = memo(function DraftIssueSummary({ nodeId }: { nodeId: string }) {
  const { t } = useTranslation();
  const context = useContext(DraftIssuesContext);
  const issues = context?.issuesByNodeId.get(nodeId);
  if (!context || !issues?.length) return null;

  return (
    <section
      aria-label={t('processDraft.issues.title')}
      className="mb-3 rounded-md border border-destructive/30 bg-destructive/5"
    >
      <h4 className="flex items-center gap-1.5 px-3 pt-2 text-xs font-semibold text-destructive">
        <AlertCircle aria-hidden className="size-3.5" />
        {t('processDraft.issues.count', { count: issues.length })}
      </h4>
      <DraftIssueList
        issues={issues}
        onGoToIssue={context.goToIssue}
        onQuickFix={context.runQuickFix}
        buttonRef={context.keepFocusInEditor}
      />
    </section>
  );
});
